/**
 * Numbering follows the boxes on the ICS 234-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS234CG.ts`.
 *
 * Boxes 1 to 3 are the read-only header. Boxes 4 to 6 are the three columns of
 * one matrix rather than three stacked boxes, which is why they are labelled
 * per column and the card wraps them in a single section. Box 7 is the
 * signature.
 */
export const ICS234_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  matrix: '4-6. Work Analysis Matrix:',
  objectives: '4. Objectives',
  objectivesSub: 'Desired Outcome',
  strategies: '5. Strategies',
  strategiesSub: 'How',
  tactics: '6. Tactics / Work Assignments',
  tacticsSub: 'Who / What / Where / When',
  preparedBy: '7. Prepared by (Planning Section Chief):',
} as const;

export const ICS234_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

export const ICS234_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';

export const ICS234_OPERATIONAL_PERIOD_HINT =
  'Click this box to set the scheduled start and end of the next operational period for this incident workspace. Working-period forms print that window.';

/**
 * The matrix is the same objectives, strategies and tactics the rest of the IAP
 * works from, not a copy, so the 202 and 204 see edits made here.
 */
export const ICS234_MATRIX_HINT =
  'Shared with the rest of the IAP: these are the incident objectives, strategies and tactics, so an edit here shows up on the 202 and 204 too. Only Operational objectives are printed.';
